@if (isCardVisible()) {
  <mwe-infobox messageKey="global.dsgvo.disclaimer" [textParams]="textParams()" />
}
